import React from 'react';
import { BusinessHero } from '@/components/ui/content-blocks';

const ReferencesHeader = () => {
  return (
    <BusinessHero
      title="Unsere Projekte"
      titleHighlight="Projekte"
      description="Entdecke, wie wir Unternehmen durch maßgeschneiderte digitale Lösungen zum Erfolg verhelfen"
      backgroundStyle="purple"
    >
    </BusinessHero>
  );
};

export default ReferencesHeader;
